/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** The cost of the product may vary depending on the channel of the order. Use DELIVERY_COST_CHANNEL if the current order is delivery, and DEFAULT_COST_CHANNEL otherwise. Marketplace and Outpost cost channels are implicit based on the request and restaurant. */
export type CostChannel = 'DEFAULT_COST_CHANNEL' | 'DELIVERY_COST_CHANNEL' | 'PICKUP_COST_CHANNEL';

export type LocationByAddressInput = {
  readonly address1?: string | null | undefined;
  readonly address2?: string | null | undefined;
  /** id for an address present in the current session. */
  readonly addressId?: string | number | null | undefined;
  readonly city?: string | null | undefined;
  /** google places id used for delivery locations search */
  readonly googlePlaceId?: string | null | undefined;
  readonly lat?: number | null | undefined;
  readonly lon?: number | null | undefined;
  readonly state?: string | null | undefined;
  readonly useCartRestaurant?: boolean | null | undefined;
  readonly zipcode?: number | null | undefined;
};

export type BundlePickupMenuQueryVariables = Exact<{
  id: string | number;
  costChannel?: Types.CostChannel | null | undefined;
}>;

export type BundlePickupMenuQuery = {
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly slug: string;
    readonly menu: {
      readonly __typename: 'Menu';
      readonly id: string;
      readonly categories: ReadonlyArray<{
        readonly __typename: 'MenuCategory';
        readonly id: string;
        readonly name: string;
        readonly products: ReadonlyArray<{
          readonly __typename: 'Product';
          readonly id: string;
          readonly name: string;
          readonly slug: string;
          readonly calories: number;
          readonly outOfStock: boolean;
          readonly cost: number;
          readonly asset: { readonly url: string };
          readonly baseProduct: {
            readonly __typename: 'BaseProduct';
            readonly id: string;
            readonly lineageKey: string | null;
          };
        }>;
      }>;
    };
  } | null;
};

export type BundleDeliveryMenuQueryVariables = Exact<{
  input: Types.LocationByAddressInput;
  costChannel?: Types.CostChannel | null | undefined;
}>;

export type BundleDeliveryMenuQuery = {
  readonly locationByAddress:
    | { readonly __typename: 'InvalidInput' }
    | {
        readonly __typename: 'Location';
        readonly restaurant: {
          readonly __typename: 'Restaurant';
          readonly id: string;
          readonly slug: string;
          readonly menu: {
            readonly __typename: 'Menu';
            readonly id: string;
            readonly categories: ReadonlyArray<{
              readonly __typename: 'MenuCategory';
              readonly id: string;
              readonly name: string;
              readonly products: ReadonlyArray<{
                readonly __typename: 'Product';
                readonly id: string;
                readonly name: string;
                readonly slug: string;
                readonly calories: number;
                readonly outOfStock: boolean;
                readonly cost: number;
                readonly asset: { readonly url: string };
                readonly baseProduct: {
                  readonly __typename: 'BaseProduct';
                  readonly id: string;
                  readonly lineageKey: string | null;
                };
              }>;
            }>;
          };
        };
      }
    | { readonly __typename: 'NoValidRestaurants' }
    | { readonly __typename: 'ValidationError' };
};

export type BundleMenuFragment = {
  readonly __typename: 'Restaurant';
  readonly id: string;
  readonly slug: string;
  readonly menu: {
    readonly __typename: 'Menu';
    readonly id: string;
    readonly categories: ReadonlyArray<{
      readonly __typename: 'MenuCategory';
      readonly id: string;
      readonly name: string;
      readonly products: ReadonlyArray<{
        readonly __typename: 'Product';
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly calories: number;
        readonly outOfStock: boolean;
        readonly cost: number;
        readonly asset: { readonly url: string };
        readonly baseProduct: {
          readonly __typename: 'BaseProduct';
          readonly id: string;
          readonly lineageKey: string | null;
        };
      }>;
    }>;
  };
};

export const BundleMenuFragmentDoc = gql`
  fragment BundleMenu on Restaurant {
    id
    __typename
    slug
    menu {
      id
      __typename
      categories {
        id
        __typename
        name
        products {
          id
          __typename
          name
          slug
          calories
          outOfStock
          cost: channelCost(costChannel: $costChannel)
          asset {
            url
          }
          baseProduct {
            id
            __typename
            lineageKey
          }
        }
      }
    }
  }
`;
export const BundlePickupMenuDocument = gql`
  query BundlePickupMenu($id: ID!, $costChannel: CostChannel) {
    restaurant(id: $id) {
      ...BundleMenu
    }
  }
  ${BundleMenuFragmentDoc}
`;

export function useBundlePickupMenuQuery(
  options: Omit<Urql.UseQueryArgs<BundlePickupMenuQueryVariables>, 'query'>,
) {
  return Urql.useQuery<BundlePickupMenuQuery, BundlePickupMenuQueryVariables>({
    query: BundlePickupMenuDocument,
    ...options,
  });
}
export const BundleDeliveryMenuDocument = gql`
  query BundleDeliveryMenu($input: LocationByAddressInput!, $costChannel: CostChannel) {
    locationByAddress(input: $input) {
      __typename
      ... on Location {
        restaurant {
          ...BundleMenu
        }
      }
    }
  }
  ${BundleMenuFragmentDoc}
`;

export function useBundleDeliveryMenuQuery(
  options: Omit<Urql.UseQueryArgs<BundleDeliveryMenuQueryVariables>, 'query'>,
) {
  return Urql.useQuery<BundleDeliveryMenuQuery, BundleDeliveryMenuQueryVariables>({
    query: BundleDeliveryMenuDocument,
    ...options,
  });
}
